module.exports = __webpack_public_path__ + "static/img/item2-bottom.64392684.png";